import {useMemo} from "react";
import {Option, OptionAttribute} from "../data";

export const useOptionsByAttribute = (options: Option[], attributeId: string) => {
    return useMemo(
        () => {
            return options.reduce<OptionAttribute[]>((total, option) => {
                const optionAttribute = option.attributes[attributeId];

                if (!optionAttribute || total.some((el) => el.id === optionAttribute.id)) {
                    return total;
                }

                total.push(optionAttribute);

                return total;
            }, []);
        },
        [attributeId, options]
    );
};
